import { FeatureFlagKey } from "../../features/types";
import { ChainIdEnum } from "../../../enums/chain";
import { ChainConfig } from "../types";
import {
  REALTIME_BRANDING,
  RPC_WSS_URL,
  getPerpetualDexConfig,
  getTokenAddress,
} from "./shared";

// ============================================
// BNB TESTNET (Chain ID: 97)
// ============================================
export const bnbTestnetConfig: ChainConfig = {
  chainId: ChainIdEnum.BNB_TESTNET,
  name: "BNB Testnet",
  shortName: "BNB",
  isTestnet: true,
  rpcUrls: [
    process.env.REACT_APP_RPC_URL ||
      "https://data-seed-prebsc-1-s1.binance.org:8545",
  ],
  rpcWsUrls: [
    RPC_WSS_URL || "wss://bsc-testnet-rpc.publicnode.com",
  ],
  wsUrl: process.env.REACT_APP_WSS_URL,
  explorerUrl: "https://testnet.bscscan.com",
  l2ExplorerUrl: "https://testnet.bscscan.com",
  nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
  wethIsErc20Collateral: true,
  tokenDecimals: {
    usdc: parseInt(process.env.REACT_APP_USDC_DECIMALS || "6", 10),
    usdt: 6,
    weth: 18,
    wbtc: 8,
    sdai: 6,
  },
  contracts: {
    erc20: {
      usdc: getTokenAddress(ChainIdEnum.BNB_TESTNET, "USDC", "0x10Fb3247775e853a7a524B04f153202C1C4337D2"),
      "usdc-native": "",
      usdt: "",
      weth: getTokenAddress(ChainIdEnum.BNB_TESTNET, "WETH", "0xa97CE2FE56E09BA3461C7d597fC08C943535c4bf"),
      wbtc: getTokenAddress(ChainIdEnum.BNB_TESTNET, "WBTC", "0x7eF2C949567f5C81Ba0Ce0F2762f04DdaE57b7E4"),
      l2usdc: "",
      l2usdt: "",
      l2weth: "",
      l2wbtc: "",
      govToken: "",
    },
    bridge: {
      l1DepositHelper: "",
      l1StandardBridge: "",
      l2StandardBridge: "",
      l2WithdrawProxy: "",
      exchangePass: "",
      strategies: "",
      staking: "",
    },
    perpetualDex: getPerpetualDexConfig(ChainIdEnum.BNB_TESTNET, {
      router: "0xB3FB765F21F8f4cc482B5485b58d4Dd5d5f39439",
      crossMargin: "",
      orderHandler: "0x4C16C6cFFe7C4943D0c05483952c129887e214BE",
      orderVault: "",
      marketFactory: "0x25F2BB09d09a4f5e8c46eD62901d9DA679677FEa",
      usdc: "0x10Fb3247775e853a7a524B04f153202C1C4337D2",
      unifiedVault: "0x11Fc1f12B2508911DE02620fd64fA173cb7B3482",
      unifiedMarginAdapter: "",
      positionHandler: "0xe80428B73cE2dD2B95fAC3EED6A9C70Be81a886F",
      backstopVault: "0x5b15319e7dC9005A3D75852449D3dE03aA192Aa1",
      oracle: "0xdc782CEBa70d4815114c47e5a45beC86E7EDe108",
      dataStore: "0x35a45d6438d32BB5f25180B7E202E357C87008C5",
      marketHandler: "0xb259803557A6af6F2863D8fA1f38FaD32801DeDe",
      balanceManager: "0x26645b15Eb63b698C973259b0c4436d355aB59b2",
      perpRouter: "0xa2a2A9aE34B9278eb82324a8E33CcEFB7a04aF9f",
      markets: {
        "BTC-PERP": "0xd2fFdc3B06262679950889697a794031AB6f288a",
        "ETH-PERP": "0x786Ce308FDAC2Ed0Dc982f6620cD93B38B60548F",
        "BNB-PERP": "0xb9d278010d5375E8dd7D6A551104E1b71Acb3F9B",
      },
    }),
  },
  signingDomain: { name: "RealTime BNB Testnet", version: "1" },
  supportsSubaccounts: false,
  supportsTpsl: true,
  // Spot CLOB is deployed here, so the spot vertical is available (it is off by
  // default and opted into per chain). See src/config/features.
  tradingTypes: {
    [FeatureFlagKey.PERPETUAL_SPOT]: true,
  },

  branding: REALTIME_BRANDING,
};
